import { render, staticRenderFns } from "./RatingScale.vue?vue&type=template&id=3e18b6de&scoped=true&"
import script from "./RatingScale.vue?vue&type=script&lang=js&"
export * from "./RatingScale.vue?vue&type=script&lang=js&"
import style0 from "./RatingScale.vue?vue&type=style&index=0&id=3e18b6de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e18b6de",
  null
  
)

export default component.exports